import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { APP_ROUTES } from '@/libs/constants'
import { useAppSelector } from '@/store/hooks'

interface SuperAdminRouteProps {
  children?: ReactNode
}

export function SuperAdminRoute({ children }: SuperAdminRouteProps) {
  const location = useLocation()
  const { isAuthenticated, user } = useAppSelector((state) => state.auth)

  if (!isAuthenticated) {
    return <Navigate to={APP_ROUTES.auth.login} state={{ from: location }} replace />
  }
  if (!user?.isSuperAdmin) {
    return <Navigate to={APP_ROUTES.home} replace />
  }
  return children || <Outlet />
}
